module.exports = __webpack_public_path__ + "static/media/gorm.a685a951.JPG";